<script>
	import { createEventDispatcher } from 'svelte';
	import { fetchConfig, postConfig } from '../api';
	import { Toggle, notifications } from '@shopboxai/sb-portal-components';
	import { onMount } from 'svelte/internal';
	import FieldEdit from './edit/FieldEdit.svelte';
	import RawEdit from './edit/RawEdit.svelte';
	import ConfigHistory from './edit/ConfigHistory.svelte';

	export let data;
	const dispatch = createEventDispatcher();
	const switchConfig = (type) => {
		currentType = type;
	};
	const loadFromHistory = (e) => {
		runFetchByConfigType = fetchConfig(currentType, data.cid, e.detail);
	};
	const save = async (e) => {
		await postConfig(currentType, data.cid, JSON.stringify(updatedConfig));
		notifications.success(`Config for ${data.cid} saved!`, 800);
	};

	let raw = true;
	let currentType = 'frontend';
	let runFetchByConfigType;
	let updatedConfig = {};

	$: if (currentType || raw) {
		console.log('fetchConfigType', currentType);
		runFetchByConfigType = fetchConfig(currentType, data.cid);
	}
	onMount(() => {
		runFetchByConfigType = fetchConfig(currentType, data.cid);
	});
</script>

<div class="header">
	<h3>
		<button on:click={() => dispatch('back')}
			><svg
				width="10"
				height="18"
				viewBox="0 0 10 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				class="svelte-1bbht2t"
				><path
					d="M9 17L1 9L9 1"
					stroke="#091EB5"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="svelte-1bbht2t"
				/></svg
			></button
		>
		<span>{data.client_name + ' , ' + data.cid}</span>
	</h3>

	<nav>
		<button class:active={currentType == 'app-configs'} on:click={() => switchConfig('app-configs')}
			>App Config</button
		>
		<button class:active={currentType == 'backend'} on:click={() => switchConfig('backend')}
			>Back End</button
		>
		<button class:active={currentType == 'frontend'} on:click={() => switchConfig('frontend')}>
			Front End</button
		>
		<button class:active={currentType == 'modelling'} on:click={() => switchConfig('modelling')}
			>Modelling</button
		>
		<button class:active={currentType == 'reporting'} on:click={() => switchConfig('reporting')}
			>Reporting</button
		>
	</nav>

	<div class="row">
		<Toggle labelText="Raw Editor" bind:value={raw} />

		<button class="primary" on:click={save}>save config</button>
	</div>
	<div>
		<ConfigHistory id={data.cid} type={currentType} on:selectHistory={loadFromHistory} />
	</div>
</div>

{#await runFetchByConfigType then value}
	{#if value}
		{#if raw}
			<RawEdit origin={value} on:change={(e) => (updatedConfig = e.detail)} />
		{:else}
			<FieldEdit {value} on:change={(e) => (updatedConfig = e.detail)} />
		{/if}
	{/if}
{/await}

<style>
	.header {
		position: sticky;
		top: 50px;
		background: #fff;
		z-index: 5;
		padding: 1em 0;
	}
	nav {
		margin: 0 auto 2em;
		max-width: 1200px;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
		padding: 0.5em 0;
	}
	.row {
		display: grid;
		align-items: center;
		justify-items: stretch;
		grid-template-columns: 1fr 1fr;

		gap: 1em;
	}
	.row button {
		margin-bottom: 1.1em;
	}
	span {
		color: var(--s-c);
	}
	nav button {
		border-left: 1px solid #ddd;
		font-size: 1em;
		padding: 1em 0;
	}
	nav button:last-of-type {
		border-right: 1px solid #ddd;
	}
	nav button.active {
		background-color: #ddd;
	}
</style>
